function hasData(result, dictionary) {
    for (const field of dictionary.fields) {
        if (result[field]) return true;
    }
    return false;
}

class Dictionary {
    constructor({name, primaryLanguage, fields, abbrieviatedName, tibetanName}) {
        this.name = name;
        this.primaryLanguage = primaryLanguage;
        this.fields = fields;
        this.abbrieviatedName = abbrieviatedName;
        this.tibetanName = tibetanName;
    }

    hasData(result) {
        return hasData(result, this);
    }
}

const dictionaries = {
    umaTibet: new Dictionary ({
        name: "Uma Tibet",
        abbrieviatedName: "Uma",
        primaryLanguage: "english",
        fields: [
          "english1",
          "english2",
          "hopkins_2015",
          "english_others",
          "definition_tibetan",
          "definition_english",
          "divisions_tibetan",
          "divisions_english",
          "synonyms_tibetan",
          "synonyms_english",
          "example_tibetan1",
          "example_tibetan2",
          "example_tibetan3",
          "example_tibetan4",
          "example_tibetan5",
          "example_tibetan6",
          "example_english1",
          "example_english2",
          "example_english3",
          "example_english4",
          "example_english5",
          "example_english6",
          "comments",
          "hackett_definitions"
        ],
    }),
    verbinator: new Dictionary ({
        name: "Verbinator",
        abbrieviatedName: "Verbinator",
        primaryLanguage: "english",
        fields: [
            'verbinator'
        ],
    }),
    rangjung: new Dictionary({
        name: "Rangjung Yeshe",
        abbrieviatedName: "RYI",
        primaryLanguage: "english",
        fields: [
            'rangjung_english'
        ]
    }),
    berzin: new Dictionary({
        name: "Berzin",
        abbrieviatedName: "Berzin",
        primaryLanguage: "english",
        fields: [
            'berzin',
            'berzin_english'
        ]
    }),
    hackettIndex: new Dictionary({
        name: "Yellow Hackett Index",
        abbrieviatedName: "HVL",
        primaryLanguage: "english",
        fields: [
            'hackett_index'
        ]
    }),
    eightFourThousand: new Dictionary({
        name: "84000",
        abbrieviatedName: "84000",
        primaryLanguage: "english",
        fields: [
            'eightfourthousand_dict',
            'eightfourthousand_def',
            'eightfourthousand_skt',
            'eightfourthousand_syn'
        ]
    }),
    tshigMdzod: new Dictionary({
        name: "Tshig Mdzod Chen Mo",
        abbrieviatedName: "Tshig Mdzod",
        tibetanName: "ཚིག་མཛོད་ཆེན་མོ།",
        primaryLanguage: "tibetan",
        fields: [
            'tshig_mdzod_chen_mo'
        ]
    }),
    dagTshig: new Dictionary({
        name: "Dag Tshig Gsar Bsgrigs",
        tibetanName: "དག་ཚིག་གསར་བསྒྲིགས།",
        abbrieviatedName: "Dag Tshig",
        primaryLanguage: "tibetan",
        fields: [
            'dag_tshig_gsar_bsgrigs'
        ]
    }),
    dungDkar: new Dictionary({
        name: "Dung Dkar Tshig Mdzod Chen Mo",
        abbrieviatedName: "Dung Dkar",
        tibetanName: "དུང་དཀར་ཚིག་མཛོད་ཆེན་མོ།་",
        primaryLanguage: "tibetan",
        fields: [
            'dung_dkar_tshig_mdzod_chen_mo'
        ]
    }),
    tsepakRigzin: new Dictionary({
        name: "Tsepak Rigdzin",
        abbrieviatedName: "TR",
        primaryLanguage: "english",
        fields: [
          'tsepak_rigdzin'
        ]
    }),
    // Translation-tool only: rows arrive from the colloquial database when
    // the includeMonlam switch is enabled (off by default)
    monlamTibetanToEnglish: new Dictionary({
        name: "Monlam Tibetan–English (Colloquial)",
        abbrieviatedName: "Monlam T-E",
        primaryLanguage: "english",
        fields: [
          'monlam_tibetan_to_english'
        ]
    })

}

const arrayOfDictionaries = Object.entries(dictionaries).map(([key, value]) => ({
    ...value,
    key: key
}));

function dictionaryNameForFieldName(field, abbreviated = false) {
    for (const dictionary of arrayOfDictionaries) {
        if (dictionary.fields.includes(field)) {
            return abbreviated ? dictionary.abbrieviatedName : dictionary.name;
        }
    }
    return null;
}

const hasContentByArray = (arrayOfDictionaryKeys, result) => {
    //console.log(`Checking hasContentByArray for dictionaries: ${arrayOfDictionaryKeys} on result:`, result);
    for (const dictionaryKey of arrayOfDictionaryKeys) {
        //console.log(`Checking dictionary: ${dictionaryKey}`);
        if (dictionaries[dictionaryKey].hasData(result)) {
            return true;
        }
    }
    return false;
}

// isDictionaryEnabledForCheck - this is a method passed in that handles checking the store to see
// if the dictionary is enabled in the settings for display.
const hasVisibleContentByArray = (arrayOfDictionaryKeys, result, isDictionaryEnabledForCheck) => {
    for (const dictionaryKey of arrayOfDictionaryKeys) {
        if (dictionaries[dictionaryKey].hasData(result) && isDictionaryEnabledForCheck(dictionaryKey)) {
            return true;
        }
    }
    return false;
}
export default {
    asObject: dictionaries,
    asArray: arrayOfDictionaries,
    dictionaryNameForFieldName: dictionaryNameForFieldName,
    hasContentByArray: hasContentByArray,
    hasVisibleContentByArray: hasVisibleContentByArray
};